
import Centrifuge from "centrifuge";
import {
  getSymbolToTokenFromMap,
  getTokenBySymbol,
} from "./helpers.js";

const centrifuge = new Centrifuge(
  process.env.REACT_APP_API_FEED
);

centrifuge.on("connect", function (ctx) {
  // console.log(
  //   "Connected with client ID " + ctx.client + " over " + ctx.transport
  // );
});

centrifuge.on("disconnect", function (ctx) {
  console.log(
    "Disconnected: " +
    ctx.reason +
    (ctx.reconnect ? ", will try to reconnect" : ", won't try to reconnect")
  );
});

centrifuge.connect();

const channelToSubscription = new Map();

function onData(message, extraArg) {
  const {
    token: ticker,
    lp,
    ext,
    v,
    ...data
  } = message.data;




  const subscriptionItem = channelToSubscription.get(`${ticker + '_' + extraArg}`);

  // console.log('ticker',subscriptionItem)

  if (subscriptionItem === undefined) {
    return;
  }

  Object.keys(subscriptionItem.lastBars).forEach((key) => {
    const indicator = key;

    const lastBar = subscriptionItem.lastBars[indicator];
    if (ext < lastBar?.time / 1000) {
      // disregard the initial catchup snapshot of trades for already closed candles
      return;
    }

    let resolution = subscriptionItem.resolution;
    if (resolution.includes("D")) {
      // 1 day in minutes
      resolution = 60 * 24;
    }
    const resolutionSeconds = resolution * 60;

    // every handler is going to handle a different custom indicator
    const lastBarSec = lastBar?.time / 1000;
    const nextBarTime = lastBarSec + resolutionSeconds;

    let toBeUpdatedBar;
    let handler;

    switch (indicator) {
      case "default":
        // check if the current time from message is greater than the next update time based on resolution?
        if (ext >= nextBarTime) {
          // make a new bar if the time is greater
          toBeUpdatedBar = {
            time: ext * 1000,
            open: lastBar?.close,
            high: lp,
            low: lp,
            close: lp,
            volume: v,
          };
        } else {
          // update the current last bar
          toBeUpdatedBar = {
            ...lastBar,
            high: Math.max(lastBar?.high, lp),
            low: Math.min(lastBar?.low, lp),
            close: lp,
            volume: lastBar?.volume + v,
          };
        }
        const chartEl = document.getElementById("ltp-chart-CE");
        if (chartEl) chartEl.value = lp;
        subscriptionItem.lastBars[indicator] = toBeUpdatedBar;

        //get the handler for the default indicator
        handler = subscriptionItem.handlers.find(
          (h) => h.customIndicator === indicator
        );

        handler?.callback(toBeUpdatedBar);
        break;


        // console.log(
        //   "cd===>",

        //   message.data.cdv
        // );
        if (ext >= nextBarTime) {
          // make a new bar if the time is greater
          toBeUpdatedBar = {
            time: ext * 1000,
            close: message.data.ve,
          };
        } else {
          // update the current last bar
          toBeUpdatedBar = {
            ...lastBar,
            close: message.data.ve,
          };
        }
        subscriptionItem.lastBars[indicator] = toBeUpdatedBar;

        //get the handler for the default indicator
        handler = subscriptionItem.handlers.find(
          (h) => h.customIndicator === indicator
        );

        handler?.callback(toBeUpdatedBar);
        break;
    }
  });
}

export function subscribeOnStream(
  symbolInfo,
  resolution,
  onRealtimeCallback,
  subscriberUID,
  onResetCacheNeededCallback,
  lastBar
) {
  console.log("subscribeOnStream-stream 1 :::::: symbolInfo");


  const theTicker = symbolInfo.ticker.split("#")[0];
  const theCustomIndicator = symbolInfo.ticker.split("#")[1] || "default";
  const token = getSymbolToTokenFromMap(theTicker);
  const channelString = token;
  const handler = {
    customIndicator: theCustomIndicator,
    ticker: symbolInfo.ticker,
    id: subscriberUID,
    callback: onRealtimeCallback,
  };
  let subscriptionItem = channelToSubscription.get(channelString + '_' + resolution);
  if (subscriptionItem && subscriptionItem.resolution === resolution) {
    const existingHandlerIndex = subscriptionItem.handlers.findIndex(
      h => h.customIndicator === theCustomIndicator
    );

    if (existingHandlerIndex !== -1) {
      // Replace stale callback with fresh one
      subscriptionItem.handlers[existingHandlerIndex] = handler;
    } else {
      subscriptionItem.handlers.push(handler);
    }
    subscriptionItem.lastBars = {
      ...subscriptionItem.lastBars,
      [theCustomIndicator]: lastBar,
    };

    subscriptionItem.handlers.push(handler);
    return;
  }


  subscriptionItem = {
    subscriberUID,
    resolution,
    lastBars: {
      ...subscriptionItem?.lastBars,
      [theCustomIndicator]: lastBar,
    },
    handlers: [handler],
  };

  const subscription = centrifuge.subscribe(channelString, (message) => onData(message, resolution));

  subscriptionItem.subscription = subscription;
  channelToSubscription.set(channelString + '_' + resolution, subscriptionItem);
}

export function unsubscribeFromStream(subscriberUID) {

  let currentChannel = '';
  let channelRemoved = false;

  for (const [channelString, subscriptionItem] of channelToSubscription) {
    const channel = subscriptionItem.subscription.channel;

    if (currentChannel && currentChannel !== channel) {
      channelRemoved = true;
    } else {
      currentChannel = channel;
    }
  }

  console.log("channel_removed", channelRemoved)

  for (const [channelString, subscriptionItem] of channelToSubscription) {
    const handlers = subscriptionItem.handlers;
    const handlerIndex = handlers.findIndex(handler => handler.id === subscriberUID);

    if (handlerIndex !== -1) {
      handlers.splice(handlerIndex, 1);

      if (handlers.length === 0) {
        // console.log("[unsubscribeBars]: Unsubscribe from streaming. Channel:", channelString);
        if (channelRemoved) {
          subscriptionItem.subscription.unsubscribe();
          console.log("[unsubscribeBars]: Unsubscribe from streaming. Channel:", subscriptionItem.subscription.channel);
        }
        channelToSubscription.delete(channelString);
        break;
      }
    }
  }




}